import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { Navigate } from 'react-router';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import { commonStyles } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import ButtonLoadingIcon from '~/modules/guarantees/form/shared/ButtonLoadingIcon.tsx';
import ApplicationHeader from '../../shared/components/ApplicationHeader.tsx';
import ApplicationPageFrame from '../../shared/components/ApplicationPageFrame.tsx';
import GuaranteesManagerApplicationSidePanelLayout from '../shared/SidePanel/GuaranteesManagerApplicationSidePanelLayout.tsx';
import { USAPOK_APPROVAL_TEXT } from './constants.ts';
import { usapokApprovalPageStyles } from './styles.ts';
import { useUsapokApprovalPage } from './useUsapokApprovalPage.ts';

const UsapokApprovalPage: React.FC = () => {
  const {
    effectiveApplicationId,
    handleCloseAlertModal,
    handleCloseSuccessModal,
    handleCloseUsapokAccessModal,
    handleSubmitApprovalLetterByUsapok,
    headerProps,
    isApplicationLoading,
    isSubmitDisabled,
    isSubmittingApprovalLetterByUsapok,
    isUsapokAccessDenied,
    isUsapokAccessLoading,
    modalAlert,
    modalSuccess,
    redirectPath,
    showGuaranteesRequestError,
  } = useUsapokApprovalPage();
  const submitStartIcon = isSubmittingApprovalLetterByUsapok ? <ButtonLoadingIcon /> : undefined;

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  if (isUsapokAccessLoading) {
    return <FullPageLoader />;
  }

  return (
    <ApplicationPageFrame
      modalAlert={modalAlert}
      modalSuccess={modalSuccess}
      onModalClose={isUsapokAccessDenied ? handleCloseUsapokAccessModal : handleCloseAlertModal}
      onSuccessModalClose={handleCloseSuccessModal}
    >
      <ApplicationHeader {...headerProps} />

      {isUsapokAccessDenied ? null : isApplicationLoading ? (
        <Box sx={commonStyles.centeredLoader}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={guaranteesClientPageStyles.applicationFlowStack}>
          <GuaranteesManagerApplicationSidePanelLayout
            applicationId={effectiveApplicationId}
            onError={showGuaranteesRequestError}
          >
            <Box sx={usapokApprovalPageStyles.callout}>
              <Typography sx={usapokApprovalPageStyles.content}>
                {USAPOK_APPROVAL_TEXT.content}
              </Typography>
            </Box>
            <Box sx={guaranteesClientPageStyles.flowPageActionsCentered}>
              <Button
                type="button"
                variant="contained"
                disabled={isSubmitDisabled}
                startIcon={submitStartIcon}
                onClick={() => {
                  void handleSubmitApprovalLetterByUsapok();
                }}
              >
                {USAPOK_APPROVAL_TEXT.confirmButton}
              </Button>
            </Box>
          </GuaranteesManagerApplicationSidePanelLayout>
        </Box>
      )}
    </ApplicationPageFrame>
  );
};

export default UsapokApprovalPage;
